<div [style.display]="isVisible() ? 'flex' : 'none'" class="item-container calculated-value-container">
  <label
    [for]="htmlId() + '_input'"
    [class]="[properties.style.toLowerCase(), 'preserve-newlines']"
    [ngStyle]="getTextStyle()"
    [title]="getTextTitle()"
    >{{ properties.valueCaptionLeft || properties.text }}</label
  >
  <div class="input-container second-column">
    <input
      [id]="htmlId() + '_input'"
      type="text"
      [value]="formControlValue()"
      [disabled]="true"
      class="calculated-value-input"
      readonly />

    @if (properties.valueCaptionRight) {
      <span class="caption-right">{{ properties.valueCaptionRight }}</span>
    }
  </div>
</div>
